import HorizontalScrollable from '@src/basic-components/HorizontalScrollable/HorizontalScrollable';
import { getDomainConfigValue } from '@src/model/config/helpers';
import { useStoreState } from '@src/model/hooks';
import { hasFlairs } from '@src/model/token/helpers';
import { propsEqualityFn, storeEqualityFn } from '@src/utils/object-utils/object-utils';
import type { FC } from 'react';
import { Fragment, memo } from 'react';
import ForumPickerButton from './ForumPickerButton';
import TopicsBarItem from './TopicsBarItem';

interface TopicsBarProps {
    tokenName: string;
    flairId?: string;
    className?: string;
    preventScrollToTop?: boolean;
}

const TopicsBar: FC<TopicsBarProps> = props => {
    const { flairId, tokenName, preventScrollToTop = false } = props;

    const token = useStoreState(state => state.token.getToken(tokenName), storeEqualityFn);

    function getScrollContainerClassname() {
        const base = 'px-4 h-12 space-x-3';
        return `${base} bg-gray-950 text-gray-50`;
    }

    function getDividerClassname() {
        const base = 'w-[1px] h-1/3 shrink-0';
        return `${base} bg-gray-50`;
    }

    function renderForumPickerButton() {
        if (!getDomainConfigValue('enableForumPicker')) return null;
        return <ForumPickerButton />;
    }

    function renderActiveFlairs() {
        if (!token || !hasFlairs(token)) return null;
        return token.activeFlairs.map(({ id, name }, i) => {
            const isActive = id === flairId;
            return (
                <Fragment key={id}>
                    <div className={getDividerClassname()} />
                    <TopicsBarItem preventScrollToTop={preventScrollToTop} isActive={isActive} id={id} name={name} tokenName={tokenName} />
                </Fragment>
            );
        });
    }

    return (
        <HorizontalScrollable id="topics-bar" scrollOffset={200} scrollContainerClassname={getScrollContainerClassname()}>
            {renderForumPickerButton()}
            {renderActiveFlairs()}
        </HorizontalScrollable>
    );
};

export default memo(TopicsBar, propsEqualityFn);
